import Task from "../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";
import Config from "../../app/config/Config";
import MockPlatformAPIService from "./MockPlatformAPIService";
import PlatformAPICommand from "./PlatformAPICommand";
import PlatformAPIEventType from "./PlatformAPIEventType";
import PlatformAPIService from "./PlatformAPIService";

export default class InitPlatformAPIServiceTask extends Task {

    /**
     * @param {Config} config 
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     */
    constructor(config, injector, commands) {
        super();

        this.execute = function (callback, progressCallback) {
            const version = config.getValue("general.version");

            const isMockPlatform = getURLParameter("mockapi") === "1" || ranj.DEBUG;
            injector.mapClass("platformAPIService", isMockPlatform ? MockPlatformAPIService : PlatformAPIService, true);
            if (isMockPlatform) {
                console.info("InitPlatformAPIServiceTask, using MockPlatformAPIService.");
            }

            commands.add(PlatformAPIEventType.INTERACTION, PlatformAPICommand);
            commands.add(PlatformAPIEventType.PROGRESS, PlatformAPICommand);
            commands.add(PlatformAPIEventType.SAVE_REQUEST, PlatformAPICommand);

            /**@type {PlatformAPIService} */
            const platformAPIService = injector.getValue("platformAPIService");
            platformAPIService.initialize(version)
                .finally(_ => {
                    platformAPIService.enableLogging(getURLParameter("logapi") == "1");
                    console.log(`InitPlatformAPIServiceTask completed.`);
                    callback(this);
                });

        }
    }

}
